export default "__VITE_ASSET__CJl0_gin__"